define( function() {
	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/document.js
// module id = 185
// module chunks = 214